import { Alert } from "react-native";

async function signIn(userId: string, email: string, username: string) {
  // console.log(userId, email, username);
}

function logError(error: Error) {
  console.log(error);
}

function logScreen(screenName: string) {
  console.log("Screen Visit: " + screenName);
}

function logMessage(message: string) {
  console.log(message);
}

function logEvent(event: string) {
  console.log("Event: " + event);
}

const Crashlytics = {
  signIn,
  logError,
  logScreen,
  logEvent,
  logMessage,
};

export default Crashlytics;
